<div class="panel">
  <ng-content select="[header]"></ng-content>
  <div class="body" [ngClass]="{ 'p-0': ui.noPadding }" [class]="id">
    <ng-content select="[body]"></ng-content>
  </div>
</div>
